import http from "@/http/aisea/axios";
const resource = "/hull_insurance/enterprises/claim_types";

export default {
  fetch(query) {
    return http.get(`${resource}`, { params: query });
  },
  delete(id) {
    return http.delete(`${resource}/${id}`);
  },
  add(body) {
    return http.post(`${resource}`, body);
  },
  update(id, payload) {
    return http.put(`${resource}/${id}`, payload);
  },
  show(id) {
    return http.get(`${resource}/${id}`);
  },
  updateClaimType(id, body) {
    return http.post(`${resource}/${id}/steps/items`, body);
  },
};
